var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "IdleTracker",
    [
      _vm.$store.getters["session/isLogged"]
        ? _c(
            "b-navbar",
            {
              staticClass: "navbar-forum-commom navbar-forum",
              attrs: { sticky: "", toggleable: "xl" }
            },
            [
              _c(
                "div",
                { staticClass: "navbar-items-align" },
                [
                  _vm.showBackButton
                    ? _c(
                        "b-nav-item",
                        {
                          staticClass: "d-block my-auto pr-2",
                          on: { click: _vm.onBackButtonClick }
                        },
                        [
                          _c("base-icon", {
                            attrs: {
                              src:
                                "/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg",
                              svgClasses: "rotate-180",
                              width: "20",
                              height: "20"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-navbar-brand",
                    {
                      staticClass: "cursor-pointer mx-auto mx-lg-0",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.goPatientMenu()
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "navbar-brand-img",
                        style: _vm.getLogoStyles,
                        attrs: { src: _vm.getLogo }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.showInSubmenu
                    ? _c(
                        "div",
                        {
                          staticClass: "pointer push-notifications-mobile",
                          on: { click: _vm.showPushNotifications }
                        },
                        [
                          _c("b-icon-bell", {
                            staticClass: "pointer",
                            attrs: { scale: "1.3" }
                          }),
                          _vm.$store.state.forum.numberPushNotifications > 0
                            ? _c(
                                "span",
                                { staticClass: "badge-forum badge-pill" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$store.state.forum
                                        .numberPushNotifications
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("b-navbar-toggle", { attrs: { target: "nav-collapse" } })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-collapse",
                { staticClass: "navCollapse", attrs: { id: "nav-collapse" } },
                [
                  _c(
                    "b-navbar-nav",
                    { staticClass: "ml-auto navbar-submenu" },
                    [
                      _vm.showInSubmenu
                        ? _c(
                            "b-nav-item",
                            {
                              staticClass: "pointer",
                              on: { click: _vm.showPushNotifications }
                            },
                            [
                              _c("b-icon-bell", {
                                staticClass: "pointer",
                                attrs: { scale: "1.3" }
                              }),
                              _vm.$store.state.forum.numberPushNotifications > 0
                                ? _c(
                                    "span",
                                    { staticClass: "badge badge-pill" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.forum
                                            .numberPushNotifications
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showInSubmenu
                        ? _c(
                            "b-nav-item",
                            [
                              !_vm.$store.state.forum.hideSearcher
                                ? _c(
                                    "b-form-group",
                                    { staticClass: "search-navbar" },
                                    [
                                      _c(
                                        _vm.inWhoInSection
                                          ? "base-button"
                                          : "b-form-input",
                                        {
                                          tag: "component",
                                          attrs: {
                                            placeholder: _vm.searchPlaceholder
                                          },
                                          on: {
                                            click: _vm.searchModalClick,
                                            keyup: _vm.searchModal
                                          },
                                          model: {
                                            value:
                                              _vm.$store.state.forum
                                                .entrySearchValue,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.$store.state.forum,
                                                "entrySearchValue",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "$store.state.forum.entrySearchValue"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.inWhoInSection
                                                ? _vm.$t(
                                                    "searchWhoInPlaceholder"
                                                  )
                                                : null
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.showInSubmenu
                        ? _c(
                            "b-nav-item",
                            [
                              _c(
                                "base-button",
                                { attrs: { outline: "", fitContent: "" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$store.state.forum.userBasicInfo.nick
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.showInSubmenu
                        ? _c(
                            "b-nav-item",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.nav-collapse",
                                  modifiers: { "nav-collapse": true }
                                }
                              ]
                            },
                            [
                              _c("lang-selector", {
                                staticClass: "d-inline-block",
                                staticStyle: { width: "max-content" },
                                attrs: { enablePortuguese: "" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-nav-item",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle.nav-collapse",
                              modifiers: { "nav-collapse": true }
                            }
                          ]
                        },
                        [
                          _c(
                            "base-button",
                            {
                              attrs: { outline: "", fitContent: "" },
                              on: { click: _vm.createNewPost }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$store.getters[
                                    "forum/forumUserIsAdminRole"
                                  ]
                                    ? _vm.$t("createNewEntry")
                                    : _vm.newPostTitle
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showInSubmenu
                        ? _c(
                            "b-nav-item",
                            {
                              staticClass: "my-auto",
                              staticStyle: { "margin-right": "1rem" }
                            },
                            [
                              _c("dropdown", {
                                staticClass: "dropdown",
                                attrs: {
                                  enablePortuguese: "",
                                  showLanguageSelector: "",
                                  showAsNavbarBtn: "",
                                  title:
                                    _vm.$store.state.forum.userBasicInfo.nick,
                                  items: _vm.dropdownLoginItems
                                },
                                on: { logOff: _vm.logOff }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.showInSubmenu
                        ? _c(
                            "div",
                            [
                              _c(
                                "b-nav-item",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle.nav-collapse",
                                      modifiers: { "nav-collapse": true }
                                    }
                                  ],
                                  on: {
                                    click: function($event) {
                                      _vm.$router
                                        .push(_vm.getPathUrl("panel/perfil"))
                                        .catch(function() {})
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "base-button",
                                    { attrs: { outline: "", fitContent: "" } },
                                    [_vm._v(_vm._s(_vm.$t("controlPanel")))]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-nav-item",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle.nav-collapse",
                                      modifiers: { "nav-collapse": true }
                                    }
                                  ],
                                  on: { click: _vm.logOff }
                                },
                                [
                                  _c(
                                    "base-button",
                                    { attrs: { outline: "", fitContent: "" } },
                                    [_vm._v(_vm._s(_vm.$t("logOff")))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.$store.getters["session/isLogged"]
        ? _c(
            "b-navbar",
            {
              staticClass: "navbar-forum-commom navbar-login",
              attrs: { sticky: "" }
            },
            [
              _c(
                "div",
                { staticClass: "navbar-items-align" },
                [
                  _vm.showBackButton
                    ? _c(
                        "b-nav-item",
                        {
                          staticClass: "d-block my-auto pr-2",
                          on: { click: _vm.onBackButtonClick }
                        },
                        [
                          _c("base-icon", {
                            attrs: {
                              src:
                                "/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg",
                              svgClasses: "rotate-180",
                              width: "20",
                              height: "20"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-navbar-brand",
                    {
                      staticClass: "cursor-pointer mx-auto mx-lg-0",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.goPatientMenu()
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "navbar-brand-img",
                        style: _vm.getLogoStyles,
                        attrs: { src: _vm.getLogo }
                      })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.showSearchNavbarOutside
                ? _c(
                    "b-nav-item",
                    { staticClass: "ml-auto" },
                    [
                      !_vm.$store.state.forum.hideSearcher
                        ? _c(
                            "b-form-group",
                            { staticClass: "search-navbar" },
                            [
                              _c(
                                _vm.inWhoInSection
                                  ? "base-button"
                                  : "b-form-input",
                                {
                                  tag: "component",
                                  attrs: { placeholder: _vm.searchPlaceholder },
                                  on: {
                                    click: _vm.searchModalClick,
                                    keyup: _vm.searchModal
                                  },
                                  model: {
                                    value:
                                      _vm.$store.state.forum.entrySearchValue,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.$store.state.forum,
                                        "entrySearchValue",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$store.state.forum.entrySearchValue"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.inWhoInSection
                                        ? _vm.$t("searchWhoInPlaceholder")
                                        : null
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "base-button",
                {
                  staticClass: "btn btn-primary fixed-padding-btn-forum",
                  class: { "ml-auto": !_vm.showSearchNavbarOutside },
                  on: {
                    click: function($event) {
                      return _vm.logIn()
                    }
                  }
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.$t("accessBtn")))]),
                  _vm._v(" "),
                  _c("base-icon", {
                    attrs: {
                      src:
                        "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                      color: "white"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      (!_vm.$store.getters["session/isLogged"] &&
        !_vm.showSearchNavbarOutside) ||
      (_vm.$store.getters["session/isLogged"] &&
        !_vm.showInSubmenu &&
        !_vm.$store.state.forum.hideOutsideSearchBar)
        ? _c(
            "b-nav-item",
            { staticClass: "search-mobile" },
            [
              !_vm.$store.state.forum.hideSearcher
                ? _c(
                    "b-form-group",
                    { staticClass: "search-navbar" },
                    [
                      _c(
                        _vm.inWhoInSection ? "base-button" : "b-form-input",
                        {
                          tag: "component",
                          attrs: { placeholder: _vm.searchPlaceholder },
                          on: {
                            click: _vm.searchModalClick,
                            keyup: _vm.searchModal
                          },
                          model: {
                            value: _vm.$store.state.forum.entrySearchValue,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$store.state.forum,
                                "entrySearchValue",
                                $$v
                              )
                            },
                            expression: "$store.state.forum.entrySearchValue"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.inWhoInSection
                                ? _vm.$t("searchWhoInPlaceholder")
                                : null
                            )
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modalForumNotifications",
            centered: "",
            "hide-footer": "",
            scrollable: ""
          },
          model: {
            value: _vm.$store.state.forum.showPushNotificationsModal,
            callback: function($$v) {
              _vm.$set(
                _vm.$store.state.forum,
                "showPushNotificationsModal",
                $$v
              )
            },
            expression: "$store.state.forum.showPushNotificationsModal"
          }
        },
        [
          _c(
            "template",
            { slot: "modal-title" },
            [
              _c("b-icon-gear", {
                staticClass: "pointer",
                attrs: { id: "showPushNotificationsOptions", scale: "1.3" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "notifications-title-modal" }, [
                _vm._v(_vm._s(_vm.$t("notifications")))
              ]),
              _vm._v(" "),
              _c(
                "b-popover",
                {
                  attrs: {
                    id: "popoverPushNotifications",
                    target: "showPushNotificationsOptions",
                    triggers: "click",
                    placement: "right"
                  }
                },
                [
                  _c(
                    "b-row",
                    { staticClass: "more-options-row" },
                    [
                      _vm.$store.state.forum.pushNotifications &&
                      _vm.$store.state.forum.pushNotifications.length > 0
                        ? _c(
                            "b-col",
                            {
                              attrs: { cols: "12" },
                              on: {
                                click: function($event) {
                                  _vm.showConfirmDelete = true
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "more-options-item" },
                                [
                                  _c("b-icon-calendar-x"),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("removeHistory")))
                                  ])
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          attrs: { cols: "12" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.goNotificationsSetting.apply(
                                null,
                                arguments
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "more-options-item" },
                            [
                              _c("b-icon-sliders"),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("settingNotifications")))
                              ])
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.$store.state.forum.pushNotifications &&
          _vm.$store.state.forum.pushNotifications.length > 0
            ? _c(
                "div",
                _vm._l(_vm.$store.state.forum.pushNotifications, function(
                  item,
                  index
                ) {
                  return _c(
                    "div",
                    {
                      key: index,
                      class: {
                        pushNotificationBox: true,
                        pendingRead: !item.readed,
                        markedSection: item.markedSectionId === item.sectionId
                      },
                      on: {
                        click: function($event) {
                          return _vm.pushNotificationClick(
                            item.entryId,
                            item.sectionId
                          )
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "pushNotificationMessage",
                        domProps: { innerHTML: _vm._s(item.message) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "datePushNotification",
                        domProps: {
                          innerHTML: _vm._s(_vm.getTimeAgoFromDate(item.date))
                        }
                      })
                    ]
                  )
                }),
                0
              )
            : _c("div", { staticClass: "noPendingNotifications" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("noPendingPushNotifications")) +
                    "\n    "
                )
              ])
        ],
        2
      ),
      _vm._v(" "),
      _vm.$store.state.loading
        ? _c("loading-anim", {
            attrs: { active: _vm.$store.state.loading, fullScreen: "" }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("arrow-up"),
      _vm._v(" "),
      _vm.$store.state.forum.showMainPage ? _c("router-view") : _vm._e(),
      _vm._v(" "),
      _c("forum-searcher", { attrs: { search: _vm.search } }),
      _vm._v(" "),
      _vm.showActivitySearch
        ? _c("forum-activity-search", {
            model: {
              value: _vm.showActivitySearch,
              callback: function($$v) {
                _vm.showActivitySearch = $$v
              },
              expression: "showActivitySearch"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("base-dialog", {
        attrs: {
          value: _vm.showConfirmDelete,
          okFn: function() {
            _vm.removePushNotifications()
            _vm.showConfirmDelete = false
          },
          cancelFn: function() {
            _vm.showConfirmDelete = false
          },
          okBtnText: _vm.$t("yes"),
          cancelBtnText: _vm.$t("no"),
          content: _vm.$t("removePushNotifications")
        }
      }),
      _vm._v(" "),
      _c(
        "base-modal",
        {
          attrs: {
            hideClose: "",
            noCloseOnBackdrop: "",
            noCloseOnScape: "",
            value: _vm.$store.state.forum.userBasicInfo.firstAccess,
            title: _vm.getModalFirstAccessTitle
          },
          on: {
            hidden: function($event) {
              _vm.$store.state.forum.userBasicInfo.firstAccess = false
            }
          }
        },
        [
          _c("div", { staticClass: "mb-4" }, [
            _vm._v(_vm._s(_vm.$t("firstAccessForum")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-4" }, [
            _vm._v(_vm._s(_vm.$t("firstAccessNickForum")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-4" },
            [
              _c("base-input", {
                model: {
                  value: _vm.$store.state.forum.userBasicInfo.nick,
                  callback: function($$v) {
                    _vm.$set(_vm.$store.state.forum.userBasicInfo, "nick", $$v)
                  },
                  expression: "$store.state.forum.userBasicInfo.nick"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mb-4" }, [
            _c("b", [_vm._v(_vm._s(_vm.$t("firstAccessFooterForum")))])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("base-button", { on: { click: _vm.saveNewNick } }, [
                _vm._v(_vm._s(_vm.$t("continue")))
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            "no-close-on-backdrop": "",
            "hide-header-close": "",
            "no-close-on-esc": "",
            size: "lg",
            centered: "",
            "hide-footer": ""
          },
          model: {
            value: _vm.showMonthlyAdviceModal,
            callback: function($$v) {
              _vm.showMonthlyAdviceModal = $$v
            },
            expression: "showMonthlyAdviceModal"
          }
        },
        [
          _c("div", { staticClass: "text-center" }, [
            _c("div", [_vm._v(_vm._s(_vm.$t("monthlyAccessAdvice")))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-5" },
              [
                _c(
                  "base-button",
                  { on: { click: _vm.resetMonthlyAccessAdvice } },
                  [_vm._v(_vm._s(_vm.$t("continue")))]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-90301aea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90301aea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/ForumNavbar.vue
// module id = 2056
// module chunks = 120